import axios from "axios";
import config  from '../../env.json';
const getAuthApi=(params:any,callback:any)=>{
    let {authToken}=params;
    try {
        axios.get(config.REACT_APP_AUTH_API_BASE+"/auth/?EndpointType=SMS")
        .then(res=>{ 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
   
}
const getEmpPermissions=(callback:any)=>{
    try {
        axios.get(config.REACT_APP_AUTH_API_BASE+"/rolespermisson/permissionsbyempid")
        .then(res=>{ 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
   
}

const getModulePermissions=(callback:any)=>{
    try {
        axios.get(config.REACT_APP_AUTH_API_BASE+"/SystemAdminPermissionByRole")
        .then(res=>{ 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
   
}
 




export {getAuthApi,getEmpPermissions, getModulePermissions}